// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,  
  name:'stage',  
  apiUrl: '/',
  cccUrl: '/',  
  //instance 3
  siteUrl:'https://r2c-stag-westeurope.otiselevator.com/',
  //instance 4
  //siteUrl:'https://r2c-stag-northeurope.otiselevator.com/',
  "idleSid": "WAc1e41a570a222a6bea20e63a97fad764",
  "busySid": "WA95a7372405ee8b889c86f29eeebef41b",
  "deleteSid": "WA90b9f2d7747ccefbc3209b5a7117c2c3",
  "offlineSid": "WA638b6e0ea58fdfda13144c9b81663ffe",
  "reservSid": "WA6419f7aa7f0d467cb2cbeb76fd197dd4",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
  // import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
